// removed by extract-text-webpack-plugin
module.exports = {"pageRoot":"BlogArticlePage__pageRoot__s9jv1","layoutWrapperMain":"BlogArticlePage__layoutWrapperMain__3QyA-","mainTitleContainer":"BlogArticlePage__mainTitleContainer__3ov_7","mainTitle":"BlogArticlePage__mainTitle__1LtrC","errorText":"BlogArticlePage__errorText__2My10","contentContainer":"BlogArticlePage__contentContainer__oLAYQ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BlogArticlePage/BlogArticlePage.css
// module id = 2290
// module chunks = 0